import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useMigrationStatus, isMigrationInProgress } from '../shared';

/**
 * TemporaryTokenMigrationRouteGuard
 *
 * This component wraps protected routes and redirects to the migration lock page
 * if a migration is in progress. Similar to how PIN lock works.
 *
 * This is TEMPORARY and can be removed by searching for "Temporary" keyword.
 */
const TemporaryTokenMigrationRouteGuard: React.FC = () => {
  const location = useLocation();
  const { data: migrationData, isLoading: isMigrationLoading, isError } = useMigrationStatus();

  // Don't check migration status while loading or if there's an error (backend deploying)
  if (!isMigrationLoading && !isError) {
    // Check if migration is in progress and redirect to token-migration-lock
    // But don't redirect if user is already on the token-migration-lock page
    if (isMigrationInProgress(migrationData?.status) && location.pathname !== '/token-migration-lock') {
      return <Navigate to="/token-migration-lock" replace />;
    }
  }

  return <Outlet />;
};

export default TemporaryTokenMigrationRouteGuard;
